module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-14.209fe9eb.svg";